export default __webpack_public_path__ + "static/media/Rectangle 371.f48c65c7.png";